import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: 'dashboard',
		loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
		data: { preload: true },
	},
	{
		path: 'dashboard-test',
		loadChildren: () => import('./dashboard-test/dashboard.module').then(m => m.DashboardTestModule),
	},
	{
		path: 'contract',
		loadChildren: () => import('./contract/contract.module').then(m => m.ContractModule),
		data: { preload: true },
	},
	{
		path: 'customer',
		loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
	},
	{
		path: 'security',
		loadChildren: () => import('./security/security.module').then(m => m.SecurityModule),
		data: { preload: true },
	},
	{
		path: 'cPanel',
		loadChildren: () => import('./cpanel/cpanel.module').then(m => m.CpanelModule),
		data: { preload: true },
	},
	{
		path: 'agent',
		loadChildren: () => import('./agent/agent.module').then(m => m.AgentModule),
		data: { preload: true },
	},
	{
		path: 'auction',
		loadChildren: () => import('./auction/auction.module').then(m => m.AuctionModule),
	},
	{
		path: 'rates',
		loadChildren: () => import('./rates/rates.module').then(m => m.RatesModule),
		data: { preload: true },
	},
	{
		path: 'chart',
		redirectTo: 'market-analytics',
	},
	{
		path: 'market-analytics',
		loadChildren: () => import('./market-analytics/market-analytics.module').then(m => m.MarketAnalyticsModule),
	},
	{
		path: 'faq',
		loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule),
	},
	{
		path: 'market-overview',
		loadChildren: () => import('./market-overview/market-overview.module').then(m => m.MarketOverviewModule),
	},
	{
		path: 'bill-reader',
		loadChildren: () => import('./bill-reader/bill-reader.module').then(m => m.BillReaderModule),
	},
	{
		path: 'task',
		loadChildren: () => import('./task/task.module').then(m => m.TaskModule),
	},
	{
		path: 'search',
		loadChildren: () => import('./search/search.module').then(m => m.SearchModule),
		data: { preload: true },
	},
	{
		path: 'attachment',
		loadChildren: () => import('./attachment/attachment.module').then(m => m.AttachmentModule),
	},
	{
		path: 'report',
		loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
		data: { preload: true },
	},
	{
		path: 'supplier',
		loadChildren: () => import('./supplier/supplier.module').then(m => m.SupplierModule),
		data: { preload: true },
	},
	{
		path: 'direct',
		loadChildren: () => import('./direct/direct.module').then(m => m.DirectModule),
	},
	{
		path: 'esign',
		loadChildren: () => import('./esign/esign.module').then(m => m.EsignModule),
	},
	{
		path: 'short-urls',
		loadChildren: () => import('./short-url/short-url.module').then(m => m.ShortUrlModule),
	},
	{
		path: 'short-url-landing',
		loadChildren: () => import('./short-url-landing/short-url-landing.module').then(m => m.ShortUrlLandingModule),
	},
	{
		path: 'rate-matrix-loader-dashboard',
		loadChildren: () => import('./rate-matrix-loader-dashboard/rate-matrix-loader-dashboard.module').then(m => m.RateMatrixLoaderDashboardModule),
	},
	{
		path: 'error',
		loadChildren: () => import('./error/error.module').then(m => m.ErrorModule),
	},
	{
		path: 'news',
		loadChildren: () => import('./news/news.module').then(m => m.NewsModule),
	},
	{
		path: 'support-center',
		loadChildren: () => import('./support-center/support-center.module').then(m => m.SupportCenterModule),
	},
	{
		path: 'market-update',
		loadChildren: () => import('./market-update/market-update.module').then(m => m.MarketUpdateModule),
	},
	{
		path: 'enterprise',
		loadChildren: () => import('./enterprise/enterprise.module').then(m => m.EnterpriseModule),
	},
	{
		path: 'prototype',
		children: [
			{
				path: 'enterprise',
				loadChildren: () => import('./prototype/prototype.module').then(m => m.PrototypeModule),
			},
		],
	},
	{
		path: 'document-templates',
		loadChildren: () => import('./document-templates/document-templates.module').then(m => m.DocumentTemplatesModule),
	},
	{
		path: 'supplier-payment-report',
		loadChildren: () => import('./supplier-payment-report/supplier-payment-report.module').then(m => m.SupplierPaymentReportModule),
	},
	{
		path: 'admin',
		loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
	},
	{
		path: 'customer-engagement',
		loadChildren: () => import('./customer-engagement/customer-engagement.module').then(m => m.CustomerEngagementModule),
	},
	{
		path: 'enterprise-engagement',
		loadChildren: () => import('./enterprise-engagement/enterprise-engagement.module').then(m => m.EnterpriseEngagementModule),
	},
	{
		path: 'agent-engagement',
		loadChildren: () => import('./agent-engagement/agent-engagement.module').then(m => m.AgentEngagementModule),
	},
	{
		path: 'referral-exchange',
		loadChildren: () => import('./referral-exchange/referral-exchange.module').then(m => m.ReferralExchangeModule),
	},
	{
		path: 'lead',
		loadChildren: () => import('./lead/lead.module').then(m => m.LeadModule),
		data: { preload: true },
	},
	{
		path: 'layered-purchasing',
		loadChildren: () => import('./layered-purchasing/layered-purchasing.module').then(m => m.LayeredPurchasingModule),
	},
	// Test-only: opens layered purchasing feedback modal, then returns to dashboard when closed
	{
		path: 'layered-purchasing-feedback-test',
		loadChildren: () => import('./modal-test/modal-test.module').then(m => m.ModalTestModule),
	},
	{
		path: 'academy',
		loadChildren: () => import('./academy/academy.module').then(m => m.AcademyModule),
		data: { preload: true },
	},
	{
		path: 'email-sent-log',
		loadChildren: () => import('./email-sent-log/email-sent-log.module').then(m => m.EmailSentLogModule),
	},
	{
		path: 'sms-sent-log',
		loadChildren: () => import('./sms-sent-log/sms-sent-log.module').then(m => m.SmsSentLogModule),
	},
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
	},
	{
		path: '**',
		redirectTo: 'dashboard',
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			//anchorScrolling: 'enabled',
			//scrollPositionRestoration: 'enabled',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
